import React from "react";
import { Icon, ff, form, HorizontalLoader } from "@mc/mc-legacy";
import { FormErrors, formValueSelector, reduxForm, SubmissionError } from "redux-form";
import { connect } from "react-redux";
import { Row, Col, Button } from "reactstrap";
import "./KontaktyNotifikaceForm.scss";
import SpravaKontaktuApi from "../../api/gen/core/SpravaKontaktuApi";
import * as TwoFactorType from "../../api/gen/core/TwoFactorType";
import { toastr } from "react-redux-toastr";
const FormActions = form.FormActions;
const FormBody = form.FormBody;

type FormData = {
  kod: string;
};

const validate = (formData: FormData) => {
  const errors: FormErrors<FormData> = {};

  if (!formData.kod) {
    errors.kod = "Ověřovací kód je povinný";
  }

  return errors;
};

class OvereniTelefonuForm extends React.Component<any> {
  static formName = "overeniTelefonuForm";

  constructor(props) {
    super(props);
    this.state = {
      data: null,
      userCodeSubmitError: false,
    };
  }

  componentDidMount() {
    const { telefon, onClose } = this.props;
    SpravaKontaktuApi.getOvereniTelefonKod(telefon)
      .then((data) => {
        this.setState({
          data,
        });
      })
      .catch(() => {
        onClose();
      });
  }

  customHandleSubmit = (e) => {
    const { telefon, onSubmit, handleSubmit } = this.props;
    handleSubmit((data) => {
      return SpravaKontaktuApi.checkOvereniTelefonKod(telefon, data.kod).then((result) => {
        switch (result.twoFactorType) {
          case TwoFactorType.NONE:
            onSubmit({
              ok: true,
            });
            break;

          default:
            this.setState({
              userCodeSubmitError: true,
              data: result,
            });
            throw new SubmissionError({
              kod: "Kód není správný",
            });
        }
      });
    })(e);
  };
  handleNovyKod = () => {
    const { change } = this.props;
    const { data } = this.state;
    SpravaKontaktuApi.repeatTelefon(data.repeatRequestCode).then((result) => {
      toastr.success("", {
        component: <div>Byla odeslána nová sms s ověřovacím kódem</div>,
      });
      change("kod", "");
      this.setState({
        data: result,
        userCodeSubmitError: false,
      });
    });
  };

  render() {
    const { submitting, handleSubmit, errors, onClose, telefon } = this.props;
    const { data, userCodeSubmitError } = this.state;

    if (!data) {
      return <HorizontalLoader />;
    }

    return (
      <form.Form onSubmit={this.customHandleSubmit}>
        <FormBody>
          <Row className={"mt-3"}>
            <Col className={"pb-2 mt-4 mb-2 ml-1"}>
              Na uvedený telefon <strong>{telefon}</strong> Vám byl zaslán ověřovací kód. Prosíme o jeho zadání.
            </Col>
          </Row>
          <Row className={"ml-1"}>
            <Col xs={"auto"}>
              <ff.String
                autoComplete={"off"}
                style={{
                  width: "160px",
                }}
                label={false}
                name="kod"
                disabled={submitting}
              />
            </Col>
            <Col>
              <Button color="link" type="button" className="pr-0 pl-0" onClick={this.handleNovyKod}>
                Zaslat sms znovu
              </Button>
            </Col>
          </Row>
          <Row className={"mb-4"}>
            <Col className={"ml-1"}>
              {userCodeSubmitError && data.remainingAttempts > 0 && (
                <p>Zbývající počet pokusů: {data.remainingAttempts}</p>
              )}
              {userCodeSubmitError && data.remainingAttempts === 0 && (
                <p>Vyčerpali jste maximální počet pokusů na zadání kódu, vyžádejte si prosím nový kód</p>
              )}
            </Col>
          </Row>
        </FormBody>
        <FormActions disabled={submitting} cancelButton={false} submitButton={false}>
          <Button disabled={submitting} type="button" onClick={onClose}>
            Zpět na nastavení kontaktů a notifikací
          </Button>
          <Button
            color="primary"
            disabled={submitting || data.remainingAttempts === 0}
            title={
              data.remainingAttempts === 0
                ? "Vyčerpali jste maximální počet pokusů na zadání kódu, vyžádejte si prosím nový kód"
                : null
            }
          >
            Ověřit kontakt
          </Button>
        </FormActions>
      </form.Form>
    );
  }
}

const reduxFormObj = reduxForm({
  form: OvereniTelefonuForm.formName,
  validate,
  initialValues: {},
})(OvereniTelefonuForm);
export default connect()(reduxFormObj);
